module.exports = __webpack_public_path__ + "static/media/27OCHA18.a2df4a27.jpg";